var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results"},[_c('div',[_c('p',[_vm._v(" Search Store: "+_vm._s(_vm.$store.getters.search)+" ")])]),_c('h1',[_vm._v("Results:")]),_c('amplify-connect',{attrs:{"query":_vm.getAMIquery},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var data = ref.data;
var errors = ref.errors;
return [(loading)?_c('div',[_vm._v("Loading...")]):(errors.length > 0)?_c('div'):(data)?_c('div',[_c('div',{attrs:{"items":data.getAmi}},[_vm._v(_vm._s(data.getAmi))])]):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }